// Customer-controlled stories. All stories remain readable if JavaScript fails.
if (!customElements.get('pogi-customer-stories')) {
  customElements.define('pogi-customer-stories', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const tabs = [...this.querySelectorAll('[data-story-tab]')];
      const panels = [...this.querySelectorAll('[data-story-panel]')];
      const tablist = this.querySelector('[data-story-tabs]');
      if (!tablist || !tabs.length || tabs.length !== panels.length) return;
      this.controller = new AbortController();
      const select = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].setAttribute('aria-hidden', String(i !== index));
          panels[i].inert = i !== index;
        });
        if (focus) tabs[index].focus({ preventScroll: true });
      };
      tablist.setAttribute('role', 'tablist');
      tabs.forEach((tab, i) => {
        tab.setAttribute('role', 'tab');
        panels[i].setAttribute('role', 'tabpanel');
        panels[i].setAttribute('aria-labelledby', tab.id);
        tab.addEventListener('click', () => select(i), { signal: this.controller.signal });
        tab.addEventListener('keydown', event => {
          const rtl = getComputedStyle(this).direction === 'rtl';
          const forward = rtl ? 'ArrowLeft' : 'ArrowRight';
          const backward = rtl ? 'ArrowRight' : 'ArrowLeft';
          let next;
          if (event.key === forward) next = (i + 1) % tabs.length;
          else if (event.key === backward) next = (i - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          select(next, true);
        }, { signal: this.controller.signal });
      });
      select(0);
      this.setAttribute('data-enhanced', '');
      tablist.hidden = false;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
